import {SET_ACTIVE_ANALYSIS_SECTION} from "./actions";
import singleAnalysisReducer from "./analysis/reducer";
import {reducer as projectsListReducer} from "./ProjectList/reducer";
import dataReducer from "./analysis/analysisDataReducer";

const appInitialState = {section: null};

const analysisProjectsReducer = (state = appInitialState, action) => {

    switch (action.type) {
        case SET_ACTIVE_ANALYSIS_SECTION:
            return {...state, section: action.section};
        default:
            return {
                ...state,
                single: singleAnalysisReducer(state.single, action),
                data: dataReducer(state.data, action),
                projectsList: projectsListReducer(state.projectsList, action),

            }
    }
};

export default analysisProjectsReducer;


// WEBPACK FOOTER //
// ./src/scenes/analysis/data/reducer.js